/**
 * Labstep
 *
 * @module components/Folder/Action/UpdateOuter
 * @desc Action to update outer folder of a folder
 */

import { EntityActionEdit } from 'labstep-web/components/Entity/Action/Edit';
import { EntityActionUpdateSearchSelect } from 'labstep-web/components/Entity/Action/Update/SearchSelect';
import { withActiveGroup } from 'labstep-web/containers/ActiveGroup';
import { ModalDefaultContainer as ModalDefault } from 'labstep-web/core/Modal/Default';
import type { Entity } from 'labstep-web/models/entity.model';
import { Folder } from 'labstep-web/models/folder.model';
import type React from 'react';
import type { FolderActionUpdateOuterProps } from './types';

export const FolderActionUpdateOuter: React.FC<
  FolderActionUpdateOuterProps
> = ({ folder, folderType, activeGroup, actionComponentProps }) => (
  <ModalDefault
    header={`Move to ${Folder.getHumanReadableEntityName(
      false,
      true,
    )}`}
    content={({ toggleModal }): JSX.Element => (
      <EntityActionUpdateSearchSelect
        entity={folder}
        optimistic
        autoFocus
        openMenuOnFocus
        entityName={Folder.entityName}
        params={{
          type: folderType,
          group_id: activeGroup?.id,
          not_id: folder.inner_folder_ids,
        }}
        getBody={(value: Entity | null): Record<string, unknown> => ({
          outer_folder_id: value ? value.id : null,
        })}
        options={{ onSuccess: toggleModal }}
        labelKey="folder_path"
        usePartialSerializer
      />
    )}
    viewComponent={({ toggleModal }): JSX.Element => (
      <EntityActionEdit
        entity={folder}
        actionComponentProps={{
          type: 'option',
          icon: 'move',
          text: 'Move',
          onClick: toggleModal,
          ...actionComponentProps,
        }}
      />
    )}
  />
);

export default withActiveGroup(FolderActionUpdateOuter);
